"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestTrainingCertificateDownloadResponse = exports.GetTrainingCertificateResponse = exports.CreateTrainingCertificateResponse = exports.CreateTrainingAnswerResponse = exports.GetTrainingAnswerResponse = exports.CreateTrainingQuestionResponse = exports.GetTrainingQuestionResponse = exports.CreateTrainingPageResponse = exports.GetTrainingPageResponse = exports.UpdateTrainingResponse = exports.CreateTrainingResponse = exports.GetTrainingResponse = exports.GetGrantedTrainingsResponse = void 0;
class GetGrantedTrainingsResponse {
}
exports.GetGrantedTrainingsResponse = GetGrantedTrainingsResponse;
class GetTrainingResponse {
}
exports.GetTrainingResponse = GetTrainingResponse;
class CreateTrainingResponse {
}
exports.CreateTrainingResponse = CreateTrainingResponse;
class UpdateTrainingResponse {
}
exports.UpdateTrainingResponse = UpdateTrainingResponse;
class GetTrainingPageResponse {
}
exports.GetTrainingPageResponse = GetTrainingPageResponse;
class CreateTrainingPageResponse {
}
exports.CreateTrainingPageResponse = CreateTrainingPageResponse;
class GetTrainingQuestionResponse {
}
exports.GetTrainingQuestionResponse = GetTrainingQuestionResponse;
class CreateTrainingQuestionResponse {
}
exports.CreateTrainingQuestionResponse = CreateTrainingQuestionResponse;
class GetTrainingAnswerResponse {
}
exports.GetTrainingAnswerResponse = GetTrainingAnswerResponse;
class CreateTrainingAnswerResponse {
}
exports.CreateTrainingAnswerResponse = CreateTrainingAnswerResponse;
class CreateTrainingCertificateResponse {
}
exports.CreateTrainingCertificateResponse = CreateTrainingCertificateResponse;
class GetTrainingCertificateResponse {
}
exports.GetTrainingCertificateResponse = GetTrainingCertificateResponse;
class RequestTrainingCertificateDownloadResponse {
}
exports.RequestTrainingCertificateDownloadResponse = RequestTrainingCertificateDownloadResponse;
//# sourceMappingURL=training.js.map